import { defineStore } from "pinia"; // 定义容器
import { menu } from '@/utils/http/Api';

export const useMenusStore = defineStore('menuList', {

    state: () => ({
        menuList: [],
        menuRouter: [],
        userinfo: {},
        tabsList: [{ id: 1, name: '首页', path: '/layout' }],
        tabsActive: '/dashboard'
    }),

    getters: {},

    actions: {
        setMenuList(data) {
            this.menuList = data;
        },
        setMenuRouter(data) {
            data.forEach(item => {
                const fullPath = item.path;
                const childPath = fullPath.replace(/^\/layout\/?/, '');
                let routerInfo = {
                    path: childPath,
                    name: item.componentName,
                    meta: item.name,
                    component: () => import(`@/views${item.path}.vue`),
                };
                this.menuRouter.push(routerInfo);
            });
        },
        setUserinfo(data) {
            this.userinfo = data;
        },
        async generateRoutes() {
            if (this.menuRouter.length > 0) {
                return Promise.resolve();
            }
            return new Promise((resolve, reject) => {

                menu().then(res => {
                    this.setMenuList(res.data);
                    this.setMenuRouter(res.data);
                    resolve();
                }).catch(err => {
                    reject(new Error(`接口请求失败: ${err.message}`));
                });

            });
        },
        setTabs(node) {
            this.tabsList.push(node);
        },
        delTabs(node) {
            this.tabsList = this.tabsList.filter(item => {
                if (item.path == node) {
                    return false;
                }
                else return true;
            });
        },
        setActive(value) {
            this.tabsActive = value;
        },
    },
});